import p5 from "p5";
import ParticleSystem from "./particleSystem";
import DataProvider from "./dataProvider";
import PressingStudy from "./pressingStudy";
import SwayStudy from "./swayStudy";
import ShoulderingStudy from "./shoulderingStudy";
import SwoopingStudy from "./swoopingStudy";

const sequencing = ["Pressing", "Sway", "Shouldering", "Swooping", "Reset"];
// const sequencing = ["Pressing", "Reset"];

let sequenceIndex = 0;
let which = sequencing[sequenceIndex];

let dataProvider;



/////
let pressingStudy;
let swayStudy;
let shoulderingStudy;
let swoopingStudy;




let particleSystem;


function sequenceProvider(whichInput) {

    if (whichInput == "Pressing") {
        //appearingRipples.draw();
        pressingStudy.draw();

    } else if (whichInput == "Sway") {
        swayStudy.draw();
        //ripples.draw();
    } else if (whichInput == "Shouldering") {
        //stickyParticles.draw();
        shoulderingStudy.draw();
    } else if (whichInput == "Swooping") {
        swoopingStudy.draw();
    }
}


function pushSequence() {

    if (sequenceIndex < sequencing.length - 1) {

        sequenceIndex += 1;
        which = sequencing[sequenceIndex];

    } else {
        sequenceIndex = 0;
        which = sequencing[sequenceIndex];

    }

}


function popSequence() {

    if (sequenceIndex > 0) {

        sequenceIndex -= 1;
        which = sequencing[sequenceIndex];

    }

}






const moveGlobalCenter = (length, which, width, height) => {
    // console.log("sert", document.getElementById("mouse_trail_path").getPointAtLength(length))
    let { x, y } = document.getElementById("mouse_trail_path").getPointAtLength(length);

    // viewBox="0 0 1228.4 702.6"
    let scaledX = (x / 1228) * width;
    let scaledY = (y / 702) * height;
    // console.log("NEW", x, y);

    if (which == "Sway") {

        swayStudy.moveCenter(scaledX, scaledY);

    } else if (which == "Pressing") {

        pressingStudy.moveCenter(scaledX, scaledY);

    } else if (which == "Shouldering") {

        shoulderingStudy.moveCenter(scaledX, scaledY);

    } else if (which == "Swooping") {

        swoopingStudy.moveCenter(scaledX, scaledY);

    }
}

export const ProxiesSketchInstance = (setGlobalWhichStudy) => (sketch) => {

    let x = 100;
    let y = 100;

    let mouseTrailTotalLength = document.getElementById("mouse_trail_path").getTotalLength();




    let width = document.body.clientWidth;
    let height = document.body.clientHeight;

    let mousePositionProgress = 0;

    sketch.setup = () => {
        sketch.createCanvas(width, height);

        sketch.frameRate(30);

        dataProvider = new DataProvider(sketch);
        particleSystem = new ParticleSystem(width, height, sketch);

        pressingStudy = new PressingStudy(sketch, width, height, particleSystem, dataProvider);
        swayStudy = new SwayStudy(sketch, width, height, particleSystem, dataProvider);
        shoulderingStudy = new ShoulderingStudy(sketch, width, height, particleSystem, dataProvider);
        swoopingStudy = new SwoopingStudy(sketch, width, height, particleSystem, dataProvider);

        sketch.colorMode(p5.HSB, 360, 100, 100, 100);

    };

    sketch.draw = () => {
        sketch.background(0);


        if (mousePositionProgress < 1) {
            mousePositionProgress += Math.random() * 0.0025;

        } else {
            mousePositionProgress = 0;

        }


        moveGlobalCenter(mousePositionProgress * mouseTrailTotalLength, which, width, height);
        dataProvider.update();
        // pressingStudy.draw();    

        // which = "Sway";
        // swayStudy.draw();

        if (which === "Reset") {
            particleSystem.reset();
            pressingStudy.reset();
            swayStudy.reset();
            shoulderingStudy.reset();
            swoopingStudy.reset();
            pushSequence();
            setGlobalWhichStudy(which);

        } else {

            sequenceProvider(which);

            if (dataProvider.shouldSwitchStudy(which) == true) {

                pushSequence();
                setGlobalWhichStudy(which);
            }

        }

    };

    // sketch.mousePressed = () => {

    //     // sequenceIndex += 1;

    //     pushSequence();

    //     setGlobalWhichStudy(which);
    // }


    sketch.mouseMoved = () => {

        if (which == "Sway") {

            swayStudy.moveCenter(sketch.mouseX, sketch.mouseY);

        } else if (which == "Pressing") {

            pressingStudy.moveCenter(sketch.mouseX, sketch.mouseY);

        } else if (which == "Shouldering") {

            shoulderingStudy.moveCenter(sketch.mouseX, sketch.mouseY);

        } else if (which == "Swooping") {

            swoopingStudy.moveCenter(sketch.mouseX, sketch.mouseY);

        }
    }

    sketch.keyPressed = () => {

        if (sketch.keyCode === sketch.UP_ARROW) {
            dataProvider.updateSum(1);
        } else if (sketch.keyCode === sketch.DOWN_ARROW) {
            dataProvider.updateSum(-1);

        }

    }
}

